module.exports = __webpack_public_path__ + "static/img/shiyi.6e434ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/shiyi.png
// module id = mM+s
// module chunks = 1